import { Box, Card, Grid, Typography, Divider } from "@mui/material";

const CardPreServicioItem = ({item}) => {
    return (
        <Card
            sx={{
                background: 'linear-gradient(135deg, #ffffff 0%, #fafbfc 100%)',
                boxShadow: '0 2px 12px rgba(0, 0, 0, 0.04), 0 1px 3px rgba(0, 0, 0, 0.08)',
                border: '1px solid rgba(0, 0, 0, 0.1)',
                borderRadius: 3,
                p: 2,
                mt: 1.5,
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                '&:hover': {
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08), 0 2px 6px rgba(0, 0, 0, 0.12)',
                    transform: 'translateY(-1px)'
                }
            }}
        >
            {/* Título Principal */}
            <Box sx={{ mb: 1.5 }}>
                <Typography 
                    variant="h6" 
                    sx={{
                        fontWeight: 600,
                        color: '#1a1a1a',
                        fontSize: { xs: 15, sm: 16 },
                        lineHeight: 1.3,
                        letterSpacing: '-0.01em'
                    }}
                >
                    {item?.nombreServicio_ds}
                </Typography>
            </Box>

            {/* Separador visual */}
            <Divider sx={{ mb: 1.5, borderColor: 'rgba(0, 0, 0, 0.08)' }} />

            <Grid container spacing={1.5}>
                <Grid item xs={12} sm={6} md={4}>
                    <Box sx={{ 
                        display: 'flex', 
                        flexDirection: 'column',
                        p: 1,
                        backgroundColor: 'rgba(99, 102, 241, 0.04)',
                        borderRadius: 1.5,
                        border: '2px solid rgba(99, 102, 241, 0.08)'
                    }}>
                        <Typography 
                            sx={{
                                color: '#6366f1',
                                fontWeight: 600,
                                fontSize: 10,
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                mb: 0.3
                            }}
                        >
                            Tipo de Servicio
                        </Typography>
                        <Typography 
                            sx={{
                                color: '#374151',
                                fontWeight: 500,
                                fontSize: 13,
                                lineHeight: 1.3
                            }}
                        >
                            {item?.tipoServicio_ds || 'No especificado'}
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Box sx={{ 
                        display: 'flex', 
                        flexDirection: 'column',
                        p: 1,
                        backgroundColor: 'rgba(16, 185, 129, 0.04)',
                        borderRadius: 1.5,
                        border: '2px solid rgba(16, 185, 129, 0.08)'
                    }}>
                        <Typography 
                            sx={{
                                color: '#10b981',
                                fontWeight: 600,
                                fontSize: 10,
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                mb: 0.3
                            }}
                        >
                            Precio
                        </Typography>
                        <Typography 
                            sx={{
                                color: '#374151',
                                fontWeight: 600,
                                fontSize: 14,
                                lineHeight: 1.3
                            }}
                        >
                            {`${item?.importeServicio_ds || '0'} ${item?.moneda_ds || ''}`}
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Box sx={{ 
                        display: 'flex', 
                        flexDirection: 'column',
                        p: 1,
                        backgroundColor: 'rgba(245, 158, 11, 0.04)',
                        borderRadius: 1.5,
                        border: '2px solid rgba(245, 158, 11, 0.08)'
                    }}>
                        <Typography 
                            sx={{
                                color: '#f59e0b',
                                fontWeight: 600,
                                fontSize: 10,
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                mb: 0.3
                            }}
                        >
                            Cantidad
                        </Typography>
                        <Typography 
                            sx={{
                                color: '#374151',
                                fontWeight: 500,
                                fontSize: 13,
                                lineHeight: 1.3
                            }}
                        >
                            {item?.cantidad_ds || 'No especificado'}
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Box sx={{ 
                        display: 'flex', 
                        flexDirection: 'column',
                        p: 1,
                        backgroundColor: 'rgba(139, 92, 246, 0.04)',
                        borderRadius: 1.5,
                        border: '2px solid rgba(139, 92, 246, 0.08)'
                    }}>
                        <Typography 
                            sx={{
                                color: '#8b5cf6',
                                fontWeight: 600,
                                fontSize: 10,
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                mb: 0.3
                            }}
                        >
                            Vigencia
                        </Typography>
                        <Typography 
                            sx={{
                                color: '#374151',
                                fontWeight: 500,
                                fontSize: 13,
                                lineHeight: 1.3
                            }}
                        >
                            {item?.vigencia_ds || 'No especificado'}
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Box sx={{ 
                        display: 'flex', 
                        flexDirection: 'column',
                        p: 1,
                        backgroundColor: 'rgba(236, 72, 153, 0.04)',
                        borderRadius: 1.5,
                        border: '2px solid rgba(236, 72, 153, 0.08)'
                    }}>
                        <Typography 
                            sx={{
                                color: '#ec4899',
                                fontWeight: 600,
                                fontSize: 10,
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                mb: 0.3
                            }}
                        >
                            Meses
                        </Typography>
                        <Typography 
                            sx={{
                                color: '#374151',
                                fontWeight: 500,
                                fontSize: 13,
                                lineHeight: 1.3
                            }}
                        >
                            {item?.cantMeses_ds || 'No especificado'}
                        </Typography>
                    </Box>
                </Grid>
                {/* Sección de Observaciones */}
                {item?.obs_ds && (
                    <Grid item xs={12}>
                        <Divider sx={{ my: 1, borderColor: 'rgba(0, 0, 0, 0.08)' }} />
                        <Box sx={{ 
                            p: 1.5,
                            backgroundColor: 'rgba(107, 114, 128, 0.04)',
                            borderRadius: 1.5,
                            border: '2px solid rgba(107, 114, 128, 0.08)',
                            borderLeft: '3px solid #6b7280'
                        }}>
                            <Typography 
                                sx={{
                                    color: '#6b7280',
                                    fontWeight: 600,
                                    fontSize: 10,
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px',
                                    mb: 0.5
                                }}
                            >
                                Observaciones
                            </Typography>
                            <Typography 
                                sx={{
                                    color: '#374151',
                                    fontWeight: 400,
                                    fontSize: 13,
                                    lineHeight: 1.4,
                                    fontStyle: item?.obs_ds ? 'normal' : 'italic'
                                }}
                            >
                                {item?.obs_ds || 'Sin observaciones adicionales'}
                            </Typography>
                        </Box>
                    </Grid>
                )}
            </Grid>
        </Card>
    )
}

export default CardPreServicioItem